export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-[45%]">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              OOPBuy vs. Manuelle Suche
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-md">
              Der direkte Vergleich zeigt deutlich: Mit dem OOPBuy Spreadsheet sparst du Zeit, Geld und Nerven. Keine stundenlange Suche mehr – alle wichtigen Informationen auf einen Blick.
            </p>
          </div>

          <div className="lg:w-[55%] w-full">
            <div className="rounded-2xl bg-background-50 border border-background-200/60 overflow-hidden">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200/60">
                    <th className="text-left py-4 px-5 font-semibold text-foreground-900">Funktion</th>
                    <th className="text-center py-4 px-5 font-semibold text-foreground-900">OOPBuy Spreadsheet</th>
                    <th className="text-center py-4 px-5 font-semibold text-foreground-900">Manuelle Suche</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { feature: 'QC Fotos', oop: true, manual: false },
                    { feature: 'Verkäufer Vergleich', oop: true, manual: false },
                    { feature: 'Preisübersicht', oop: true, manual: false },
                    { feature: 'Kategorien', oop: true, manual: false },
                    { feature: 'Zeit sparen', oop: true, manual: false },
                    { feature: 'Direkte Shop-Links', oop: true, manual: false },
                  ].map((row, i) => (
                    <tr key={row.feature} className={`border-b border-background-200/40 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                      <td className="py-3.5 px-5 text-foreground-800 font-medium">{row.feature}</td>
                      <td className="text-center py-3.5 px-5">
                        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-accent-100">
                          <i className="ri-check-line text-accent-600 text-sm"></i>
                        </span>
                      </td>
                      <td className="text-center py-3.5 px-5">
                        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-foreground-100">
                          <i className="ri-close-line text-foreground-400 text-sm"></i>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}